import { render, staticRenderFns } from "./Proportion.vue?vue&type=template&id=7026e88e&scoped=true&"
import script from "./Proportion.vue?vue&type=script&lang=js&"
export * from "./Proportion.vue?vue&type=script&lang=js&"
import style0 from "./Proportion.vue?vue&type=style&index=0&id=7026e88e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7026e88e",
  null
  
)

export default component.exports